import React from 'react';
import { useLocation, Route, Redirect } from 'react-router-dom';

const GuardedRoute = ({
  component: Component,
  checkAuthenticated,
  redirectPath,
  ...rest
}) => {
  const {
    pathname: fromPathName,
    search,
    state,
  } = useLocation();

  return (
    <Route
      {...rest} // eslint-disable-line 
      render={(props) => {
        if (!checkAuthenticated()) {
          return (
            <Redirect to={{
              pathname: redirectPath,
              state: {
                afterLoginUrl: `${fromPathName}${search}`,
                action: 'login',
                ...state,
              },
            }}
            />
          );
        }
        return <Component {...props} /> // eslint-disable-line
      }}
    />
  );
};

export default GuardedRoute;
